import usePreloadModules from './usePreloadModules';

export default function LazyModulesPreloading() {
  usePreloadModules();
  return <></>;
}
